export default __webpack_public_path__ + "static/media/640_portfolio03-en-mobile.166b66d1.png";